<hr />
<ng-container *ngFor="let textBlock of content; let isLastContentBlock = last">
  <span class="info-text" *ngIf="!textBlock.ctaCb">{{ textBlock.text }}</span>
  <a class="cta" *ngIf="!!textBlock.ctaCb" (click)="textBlock.ctaCb()">{{ textBlock.text }}</a>
  <span class="sp-pr-3" *ngIf="!isLastContentBlock">&nbsp;</span>
</ng-container>
